import React, { useEffect, useState } from 'react';
import { history } from 'store';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

let unblock = () => {
};

const NavigationPrompt = ({ children, when }) => {
  const [nextLocation, setLocation] = useState(null);
  const [openModal, setModal] = useState(false);
  const updatePrompt = (location) => {
    setLocation(location);
    setModal(true);
  };

  useEffect(() => {
    unblock = history.block((location) => {
      if (when) {
        updatePrompt(location);
      }
      return !when;
    });
    return () => unblock();
  }, [when]);

  const onCancel = () => {
    setLocation(null);
    setModal(false);
  };

  const navigateToNextLocation = () => {
    unblock();
    history.push(nextLocation.pathname);
  };

  return (
    <div>
      {children(openModal, navigateToNextLocation, onCancel)}
    </div>
  );
};

NavigationPrompt.propTypes = {
  when: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired
};

export default withRouter(NavigationPrompt);
